export function LocationPin(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      {...props}
    >
      <path
        d="M3.75 0.5C1.67779 0.5 0 2.17996 0 4.25C0 5.63901 0.468574 6.07307 2.95451 10.0591C3.32141 10.6473 4.17901 10.6466 4.54547 10.0591C7.03272 6.07098 7.5 5.63873 7.5 4.25C7.5 2.17779 5.82004 0.5 3.75 0.5ZM3.75 9.5625C1.26125 5.57199 0.9375 5.32008 0.9375 4.25C0.9375 2.6967 2.1967 1.4375 3.75 1.4375C5.3033 1.4375 6.5625 2.6967 6.5625 4.25C6.5625 5.31549 6.26629 5.52783 3.75 9.5625ZM2.1875 4.25C2.1875 3.38705 2.88705 2.6875 3.75 2.6875C4.61295 2.6875 5.3125 3.38705 5.3125 4.25C5.3125 5.11295 4.61295 5.8125 3.75 5.8125C2.88705 5.8125 2.1875 5.11295 2.1875 4.25Z"
        fill="black"
      />
    </svg>
  );
}
